export const DEFAULT_LOCALE = 'en-GB';
export const ALL_NUMERIC_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
};
export const DEFAULT_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
};

export const DEFAULT_TIME_ZONE = 'Asia/Singapore';
